import { Site } from '@envato/foundation-types'
import * as React from 'react'

import { ILocationParams } from '../../../common/reducers/reactRouterLocation'
import AutoSuggest from '../../components/autosuggest/'
import createAutoSuggestDataContainer from '../../components/autosuggest/autoSuggestDataContainer'
import createAutoSuggestLogicContainer from '../../components/autosuggest/autoSuggestLogicContainer'
import * as searchResultHeadersStyles from '../../components/header/searchResultHeaders.module.css'
import SearchResultHeaders from '../../components/searchResultHeaders'
import * as styles from './searchHeader.module.css'

const AutoSuggestContainer = createAutoSuggestDataContainer(
  createAutoSuggestLogicContainer(AutoSuggest)
)

interface IProps {
  location: any
  totalHits: number
  didYouMeanByTerms: any[]
  authorSuggestion: any
  searchHeadings: any
  currentSite: Site
  locationParams: ILocationParams
  makeSearchLink: (params: ILocationParams, currentSite?: Site) => string
  openModal: (data: any) => any
}

const SearchHeader = ({
  totalHits,
  didYouMeanByTerms,
  authorSuggestion,
  searchHeadings,
  currentSite,
  locationParams,
  makeSearchLink
}: IProps) => {
  const seoMeta = {
    heading: searchHeadings.heading,
    subHeading: searchHeadings.sub_heading
  }
  const searchResultHeaderProps = {
    locationParams,
    totalHits,
    seoMeta,
    didYouMeanByTerms,
    authorSuggestion,
    styles: searchResultHeadersStyles,
    TagName: 'h1'
  }

  return (
    <div className={styles.searchPageHeader}>
      <AutoSuggestContainer
        inputName="term"
        value={locationParams.term}
        placeholder="Search within these results"
        currentSite={currentSite}
        locationParams={locationParams}
        makeSearchLink={makeSearchLink}
      />
      <SearchResultHeaders {...searchResultHeaderProps} />
    </div>
  )
}

export default SearchHeader
